import { __makeTemplateObject, __read, __spread } from "tslib";
import { css, palette2, spacing } from '../../../../foundation';
import { RcDialogTitleSpacings } from '../utils';
export var DialogTitleStyle = function (props) {
    var size = props.size, spaceProp = props.space, display = props.display;
    var paddingValue = spaceProp !== undefined
        ? spaceProp instanceof Array
            ? spaceProp
            : [spaceProp]
        : RcDialogTitleSpacings[size];
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n\n    padding: ", ";\n\n    display: ", ";\n  "], ["\n    color: ", ";\n\n    padding: ", ";\n\n    display: ", ";\n  "])), palette2('neutral', 'f06'), spacing.apply(void 0, __spread(paddingValue)), display);
};
var templateObject_1;
